import { api } from "./axios"
import { API_ENDPOINTS } from "./config"
import { type AxiosResponse } from "axios"
import { type  ErrorResponse } from "../types/common"
import { type BaseQueryParams, type CourseDto } from "../../common"

export function getCourses(params?: Partial<BaseQueryParams>): Promise<AxiosResponse<{
  totalCount: number
  courses: Array<CourseDto>
}, ErrorResponse>> {
  return api.get(API_ENDPOINTS.courses, { params })
}

export function getCourseById(courseId: string, slug?: string): Promise<AxiosResponse<CourseDto, ErrorResponse>> {
  return api.get(`${API_ENDPOINTS.courses}/${courseId}${slug ? `/${slug}` : ""}`)
}

export function updateCourse(courseId: string, body: FormData): Promise<AxiosResponse<CourseDto, ErrorResponse>> {
  return api.patch(`${API_ENDPOINTS.courses}/${courseId}`, body)
}


export function toggleCoursePublish(courseId: string, published: boolean): Promise<AxiosResponse<CourseDto, ErrorResponse>> {
  return Promise.reject({ message: `temporary unavailable. courseId=${courseId}` })
  // return api.patch(`${API_ENDPOINTS.course}/${courseId}`, { published })
}

export function createCourse(body: FormData): Promise<AxiosResponse<CourseDto, ErrorResponse>> {
  return api.post(API_ENDPOINTS.courses, body)
}

export function removeCourse(courseId: string): Promise<AxiosResponse<unknown>> {
  return api.delete(`${API_ENDPOINTS.courses}/${courseId}`)
}
